import React from 'react'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { Link } from 'gatsby'
import Line from './line'
import './section.css'

const block = 'section'


const Section = ({
  align = 'left',
  path,
  image,
  title,
  blurb
}) => {
  const [hovered, setHovered] = useState(false)

  return (
    <Link
      className={ block }
      to={ path }
      onMouseOver={ () => setHovered(true) }
      onMouseOut={ () => setHovered(false) }
    >
      <figure
        className={ `${block}__image` }
        style={{
          marginLeft: align === 'right' ? 16 : 0,
          marginRight: align === 'left' ? 16 : 0,
          order: align === 'right' ? 1 : 0,
          filter: hovered ? 'brightness(0.9)' : 'none',
          backgroundColor: hovered ? '#DEDEDE' : '#F3F3F3',
          backgroundImage: `url(${require(`../images/${image}`)})`
        }}
      >
        <Line
          position={ `top-${align}` }
          offset={ 8 }
          length={ hovered ? 125 : 100 }
        />
        <Line
          position={ `top-${align}` }
          orientation="vertical"
          offset={ 8 }
          length={ hovered ? 25 : 50 }
        />
      </figure>
      <div>
        <h2 
          className={ `${block}__title` }
          style={{ textAlign: align }}
        >
          <span>
            { title }
            <Line
              position={ `bottom-${align === 'left' ? 'right' : 'left'}` }
              length={ hovered ? 60 : 50 }
            />
          </span>
        </h2>
        <p
          className={ `${block}__description` }
          style={{ textAlign: align }}
        >
          { blurb }
        </p>
      </div>
    </Link>
  )
}

Section.propTypes = {
  align: PropTypes.oneOf([ 'left', 'right' ]),
  path: PropTypes.string.isRequired,
  title: PropTypes.string,
  blurb: PropTypes.string
}

export default Section